import { capitalize } from 'helpers'

const useTransformName = () => {
  const transformName = (name) => {
    const splittedName = name?.split('_') || ''
    if (splittedName.length === 3) {
      const [domain, secondDomainWord, variant] = splittedName || []

      return variant === 'ALL'
        ? capitalize(domain + ' ' + secondDomainWord || '')
        : capitalize(variant || '')
    } else {
      const [domain, variant] = splittedName || []

      // Use a first element from splittedName as name if there is ALL ot there is no variant
      return variant === 'ALL' || !variant
        ? capitalize(domain || '')
        : capitalize(variant || '')
    }
  }

  return transformName
}

export default useTransformName
